import React from 'react'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { Flex } from '../../Components/Common/Flex'
import { Text } from '../../Components/Common/Text'
import { useCInfiniteQuery } from '../../Services/QueryCache'
import { Button } from '../../Components/Common/Button'
import { columnProps } from '../../Services/Functions'
import { useParams } from 'react-router-dom'
import { Calendar } from 'primereact/calendar'

export const List = () => {
  const { environmentId } = useParams()
  const [datesSearch, setDatesSearch] = React.useState([new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 1), new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1)])

  const { data: forms = [] } = useCInfiniteQuery(['forms', environmentId, datesSearch])

  return (
    <Flex fw>
      <Flex fw row>
        <Text value='Elenco Form' size={22} bold />
      </Flex>
      <Flex fw style={{ marginTop: 20 }}>
        <Calendar
          hideOnRangeSelection
          value={datesSearch} selectionMode='range' onChange={(e) => {
            setDatesSearch(e.value)
            e.value?.filter(Boolean).length === 2 && setDatesSearch(e.value)
          }}
          locale='it' dateFormat='dd/mm/yy' style={{ width: 250 }}
          inputStyle={{ borderRadius: 20, height: 44, textAlign: 'center' }}
        />

      </Flex>
      <DataTable
        style={{ width: '100%', marginTop: 20 }} filterDisplay='row' className='TableSignatures' sortField='createdAt' sortOrder={-1}
        value={forms} emptyMessage='Nessuna form presente' responsiveLayout='scroll' paginator rows={10}
      >
        <Column field='mappedDocument.name' {...columnProps('Nome documento')} />
        <Column
          field='blankForm.uri' {...columnProps('Url Form in Bianco')}
          body={(row) => row?.blankForm?.uri && <Button label='Apri' icon='fa-duotone fa-external-link' onClick={() => window.open(row?.blankForm?.uri)} />}
        />
        <Column
          field='compiledForm.uri' {...columnProps('Url Form Compilato')}
          body={(row) => row?.compiledForm?.uri ? <Button label='Apri' icon='fa-duotone fa-external-link' onClick={() => window.open(row.compiledForm?.uri)} /> : 'Non compilato'}
        />
        <Column field='error' {...columnProps('Errore')} body={(row) => row.error ? 'Si' : 'No'} />
        <Column field='createdAt' {...columnProps('Data')} body={(row) => new Date(row.createdAt).toLocaleString()} />
      </DataTable>
    </Flex>
  )
}
